(function IIFE() {
    'use strict';

    /////////////////////////////

    function WidgetPendingActionsController() {
         'ngInject';

        // eslint-disable-next-line @typescript-eslint/no-this-alias
        const vm = this;

        /**
         * Set parent controller.
         *
         * @param {Object} parentCtrl The parent controller object.
         */
        this.setParentController = function setParentController(parentCtrl) {
            vm.parentCtrl = parentCtrl;
        };

        /**
         * Get widget classes.
         *
         * @return {Array} An array of widget css classes.
         */
        function getWidgetClass() {
            const widgetClass = [];

            vm.parentCtrl.getWidgetClass(widgetClass);

            return widgetClass;
        }

        function isEmpty() {
            return false;
        }

        /**
         * Function that conditions the rendering of the widget content.
         */
        function isWidgetEmpty() {
            return isEmpty();
        }

        /**
         * In designer mode, when the widget is empty
         *
         * In reader mode, when the widget is empty, it is not displayed at all
         */
        function isWidgetHidden() {
            return !vm.parentCtrl.designerMode() && isEmpty();
        }

        vm.getWidgetClass = getWidgetClass;
        vm.isWidgetEmpty = isWidgetEmpty;
        vm.isWidgetHidden = isWidgetHidden;
    }

    /////////////////////////////

    function WidgetPendingActionsDirective() {
        'ngInject';

        function link(scope, el, attrs, ctrls) {
            ctrls[0].setParentController(ctrls[1]);
        }

        return {
            bindToController: true,
            controller: WidgetPendingActionsController,
            controllerAs: 'vm',
            link: link,
            replace: true,
            require: ['widgetPendingActions', '^widget'],
            restrict: 'E',
            scope: {
                widget: '=',
            },
            templateUrl: '/client/front-office/modules/content/modules/widget/modules/widget-pending-actions/views/widget-pending-actions.html',
        };
    }

    /////////////////////////////

    window.angular.module('Widgets').directive('widgetPendingActions', WidgetPendingActionsDirective);
})();
